/**
 * AppShell — Root layout wrapper for the entire application.
 *
 * Provides the structural scaffold: fixed top nav + full-height content area.
 * All routes should render inside AppShell to get consistent viewport behavior.
 *
 * Wave A9.13: UI Modernization
 */
import React from 'react';
// Phase 11AA (P1-5): Global slot rendering for plugin UI contributions
import { SlotRenderer } from '@neuro/plugin-sdk/ui';
import './layout.css';

export interface AppShellProps {
  /** Top navigation element */
  navbar?: React.ReactNode;
  /** Main content (routes) */
  children: React.ReactNode;
  /** Additional CSS class names */
  className?: string;
}

export function AppShell({ navbar, children, className = '' }: AppShellProps) {
  return (
    <div className={`nc-app-shell ${className}`}>
      {navbar}
      <div className="nc-app-shell__body">
        {/* Phase 11AA (P1-5): Global sidebar slot for plugin panel contributions */}
        <SlotRenderer slotId="global.sidebar" className="nc-app-shell__sidebar-slot" />
        {children}
      </div>
      {/* Phase 11AA (P1-5): Global footer slot for plugin footer contributions */}
      <SlotRenderer slotId="global.footer" className="nc-app-shell__footer-slot" />
    </div>
  );
}

export default AppShell;
